<member-onboarding-step-shell
  eyebrow="Step 2 of 5"
  heading="Review your W-9"
  sub="We've pre-filled everything we know. Add your tax ID number below, review the details, then sign to submit."
>
  <member-caqh-stepper shellStepper [activeIndex]="1" [subStepCount]="3" [activeSubStep]="0" subStepNavMode="all" [enableNodeNav]="false" (navigate)="onCrumbNavigate($event)" />

  @if (isLoading()) {
    <div class="w9-review-page__skeleton"></div>
  } @else if (loadError() === 'no-interview') {
    <div class="w9-review-page__error">
      Complete the W-9 chat first.
      <a routerLink="/account/w9">Go back to chat</a>
    </div>
  } @else if (loadError() === 'generic') {
    <div class="w9-review-page__error">Something went wrong, please refresh.</div>
  } @else {
    <div class="w9-review-page__card">
      <div #pdfContainer class="w9-review-page__pdf-container w9-pdf-viewer">
        <canvas #pdfCanvas class="w9-review-page__canvas"></canvas>
        <div #pdfAnnotationLayer class="w9-review-page__annotation-layer annotationLayer"></div>
        <!-- Signature + date overlaid at signature line position (page 1, ~74% from top) -->
        <input
          #sigInput
          class="w9-review-page__sig-input"
          type="text"
          placeholder="Type your full legal name"
          [value]="signatureValue()"
          (input)="signatureValue.set($any($event.target).value)"
          (focus)="showHint(sigInput, SIG_TIP)"
          (blur)="hideHint()"
          aria-label="Signature"
        />
        <input
          class="w9-review-page__date-input"
          type="text"
          [value]="today"
          readonly
          aria-label="Date"
        />
      </div>
      <div class="w9-review-page__form-footer">
        <a class="w9-review-page__btn-secondary" routerLink="/dashboard">Save and finish later</a>
        <button
          class="w9-review-page__btn-primary"
          [disabled]="!canSubmit()"
          (click)="onSubmit()"
        >
          {{ isSubmitting() ? 'Submitting…' : 'Submit W-9 →' }}
        </button>
      </div>
    </div>
  }

  <div #w9HintPanel class="w9-review-page__hint-panel"></div>

  <member-w9-agent-panel
    shellPanel
    [providerId]="providerId"
    [providerFirstName]="providerFirstName"
    [tinType]="resolvedTinType()"
    (fieldsUpdated)="onFieldsUpdated()"
  ></member-w9-agent-panel>

</member-onboarding-step-shell>
